import { JOB_TARGET_GROUPS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const JobTargetGroupsService = {
  getAll: (params: any) => requests.get(`${JOB_TARGET_GROUPS_URL}`, params),
  create: (params: any) => requests.post(`${JOB_TARGET_GROUPS_URL}`, params),
  getSingle: (id: number) => requests.get(`${JOB_TARGET_GROUPS_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${JOB_TARGET_GROUPS_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${JOB_TARGET_GROUPS_URL}/${id}`),
};